import React, { useEffect } from "react"

import { useNavigate } from "react-router-dom"

import { LogoutHelper } from "../../helpers/logout.helper"
import { useAppDispatch } from "../../store/appDispatch.hook"

export const LogoutComponent: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            LogoutHelper.logout(dispatch, undefined, navigate)
        })

        return () => {
            clearTimeout(timeoutId)
        }
    }, [])

    return null
}
